import AppStore from "@/utils/store/AppStore"
import { ModuleName, TAPIPayload, TAdvancedFilterAPI } from "@/utils/store/AppStore.types"
import { useGridApiRef } from "@mui/x-data-grid"
import { UseInfiniteQueryResult, useQueryClient } from "@tanstack/react-query"
import { useRef } from "react"
import { calculateToFromFilter } from "./InfiniteTableExt"

const useInfiniteTable = (key: ModuleName) => {
  const prevRangeFilters: TAPIPayload = calculateToFromFilter(AppStore.counterCardFilter[key])
  const prevAdvFilters: TAdvancedFilterAPI = { ...AppStore.advancedFilterCache[key] }
  const filterRef = useRef<TAdvancedFilterAPI>({ ...prevRangeFilters, ...prevAdvFilters })
  const sortRef = useRef<{field_name: string; orderBy: 'asc' | 'desc'}>({field_name: '', orderBy: 'asc'})
  const isNextPage = useRef(true)
  const tableAPIRef = useGridApiRef()
  const queryClient = useQueryClient()

  const resetQuery = (queryRef: Partial<UseInfiniteQueryResult>) => {
    isNextPage.current = true
    queryClient.setQueryData([key], (data: any) => ({
      pages: [],
      pageParams: 1,
    }))
    if (queryRef?.refetch) queryRef.refetch()
  }

  return { filterRef, sortRef, isNextPage, infiniteTableKey: key, tableAPIRef, queryClient, resetQuery }
}

export default useInfiniteTable
